module.exports = __webpack_public_path__ + "img/仙人掌-1.15b6a7d0.jpg";